<template>
    <section class="featured light-bg pt-55 pb-40">
      <div class="container">
        <div class="row">
          <div class="col-xl-12">
            <div class="section__head d-flex justify-content-between mb-30">
              <div class="section__title">
                <h5 class="st-titile">Top Featured Products</h5>
              </div>
              <div class="button-wrap">
                <router-link to="/shop">See All Products <i class="fas fa-chevron-right"></i></router-link>
              </div>
            </div>
          </div>
        </div>
        <div v-if="loading" class="row">
          <div class="col-12 py-4 text-center text-muted">Loading featured products…</div>
        </div>
        <div v-else-if="!featured_prd.length" class="row">
          <div class="col-12 py-4 text-center text-muted">No featured products yet. Add them from the admin panel.</div>
        </div>
        <div v-else class="row">
          <div class="col-xl-6 col-lg-12">
            <product-feature-single-big :product="featured_first"></product-feature-single-big>
          </div>
          <div class="col-xl-6 col-lg-12">
            <div class="row">
              <div
                v-for="product in featured_sm_prd.slice(0, 2)"
                :key="product.id || product.product_id"
                class="col-md-6"
              >
                <product-single-feature :product="product"></product-single-feature>
              </div>
            </div>
            <div class="row">
              <div
                v-for="product in featured_sm_prd.slice(2, 4)"
                :key="product.id || product.product_id"
                class="col-md-6"
              >
                <product-single-feature :product="product"></product-single-feature>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </template>
  
<script>
import ProductFeatureSingleBig from '@/components/product/product-feature-single-big.vue'
import ProductSingleFeature from '@/components/product/product-single-feature.vue'
import { useProductFilterStore } from "@/stores/useProductFilterStore"

export default {
  name: "HeaderOne",
  components: {
    ProductFeatureSingleBig,
    ProductSingleFeature
  },
  data() {
    const store = useProductFilterStore()
    return {
      store,
      cate_menu: false,
      isSidebarOpen: false,
      loading: true,
      featured_prd: [],
      featured_first: {},
      featured_sm_prd: []
    }
  },
  methods: {
    normalizeFeaturedRow(item) {
      if (!item || typeof item !== 'object') return null
      const id = item.id ?? item.pid ?? item.product_id
      if (id == null || id === '') return null
      const discountRaw =
        item.discount_percentage ??
        item.special_discount_percentage ??
        item.discount_presentage ??
        0
      const discountNum = Number(discountRaw)
      const discount = Number.isFinite(discountNum) ? discountNum : 0
      return {
        ...item,
        id: Number(id),
        product_id: Number(id),
        title: item.title ?? item.product_name ?? '',
        image: item.image ?? '',
        price: Number(item.price ?? item.web_price ?? 0),
        feature_lists: Array.isArray(item.feature_lists) ? item.feature_lists : [],
        discount_percentage: discount,
        special_discount_percentage: item.special_discount_percentage ?? discount,
      }
    },
    async fetchProducts() {
      this.loading = true
      try {
        const response = await this.$axios.get('/top-featured-products')
        const raw = response.data
        const rows = Array.isArray(raw) ? raw : raw?.rows ?? raw?.data ?? []
        const normalized = rows.map((r) => this.normalizeFeaturedRow(r)).filter(Boolean)
        this.featured_prd = normalized.slice(0, 5)
        this.featured_first = this.featured_prd[0] || {}
        this.featured_sm_prd = this.featured_prd.slice(1)
      } catch (error) {
        console.error('Error fetching featured products:', error)
        this.featured_prd = []
        this.featured_first = {}
        this.featured_sm_prd = []
      } finally {
        this.loading = false
      }
    }
  },
  mounted() {
    this.fetchProducts()
  }
}
</script>
